<template>

    <div class="column col-12 col-mx-auto">
                        


        <div class="wrap">
            
        
            <h3 class="entry-title" > <i class="fas fa-check"></i> Dziękujemy za cierpliwość, <br> z radością możemy zaproponować Ci kwotę: </h3>  


            <h1 class="offered text-center" v-dynamic="formatedAmount"></h1>


            <div class="d-flex justify-content-center">
                <div class="col-lg-4 mb-5 order-2 order-lg-2">          


                    <!-- Slider wyboru kwoty z gradientem -->
                    <div id="calc-app" class="wrapper calc proposal" data-app>

                        <div class="params">
                            <div class="slider-label">Wybierz kwotę pożyczki:</div>

                            <v-slider class="amount-slider mt-1 mb-3"
                                v-model="loanAmount"
                                :tick-labels="sliderLabels"
                                :min="minAmount"
                                :max="maxAmount"
                                :step="step"
                                ticks="always"
                                tick-size="4"
                                @input="onInput">
                            </v-slider>
                        </div>

                        <div class="details">
                            <div class="tab-content">
                                <div class="loan-details py-3 px-2">
                                    <div class="row">
                                        <div class="col col-auto me-auto">
                                            Kwota:
                                        </div>
                                        <div class="col col-auto">
                                            {{loanAmount}} zł
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-auto me-auto">
                                            Miesięczna rata:
                                        </div>
                                        <div class="col col-auto">
                                            {{installmentAmount}} zł
                                        </div>
                                    </div>                                
                                    <div class="row">
                                        <div class="col col-auto me-auto">
                                            Okres:
                                        </div>
                                        <div class="col col-auto">
                                            {{loanTenor}} {{ tenorSign == 'd' ? 'dni' : 'mc' }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-auto me-auto">
                                            Data spłaty:
                                        </div>
                                        <div class="col col-auto">
                                            {{finishDate}}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-auto me-auto">
                                            Prowizja:
                                        </div>
                                        <div class="col col-auto">
                                            {{service}} zł
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-auto me-auto">
                                            Oprocentowanie:
                                        </div>
                                        <div class="col col-auto">
                                            {{interest}} zł
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col col-auto me-auto">
                                            RRSO:
                                        </div>
                                        <div class="col col-auto">
                                            {{rrso}} %
                                        </div>
                                    </div>
                                    <div class="row summary">
                                        <div class="col col-auto me-auto">
                                            Razem:
                                        </div>
                                        <div class="col col-auto">
                                            {{total}} zł
                                        </div>
                                    </div>                          
                                </div>

                                <div class="text-center info-link pb-3">
                                    <a class="plain" href="#" @click="openModal">Formularz informacyjny</a>
                                </div>   
                            </div>
                        </div>

                    </div>
              
              </div>
            </div>
    


        </div>


        <div class="text-center mt-5 mb-5">

            <a key="btn-prev"  class="form-button btn btn-outline-secondary btn-lg me-2" @click="resign" ><i class="icon flaticon-left-arrow"></i> REZYGNUJĘ </a>            


            <a  key="btn-next"  class="form-button btn btn-outline-primary btn-lg me-2" @click="accept" > ZGADZAM SIĘ <i class="icon flaticon-right-arrow"></i></a>

                          
        </div>


        <!-- Modal -->
        <div  class="modal fade" ref="modal" >
          <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-header container dark-bg">
                <div class="col-auto me-auto ">
                  <h3>Formularz Informacyjny</h3>
                </div>
                  <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div class="modal-body" v-dynamic="details">
            
                </div>


                <div class="modal-footer justify-content-center">

                  <button type="button" class="btn btn-lg btn-success" data-bs-dismiss="modal"> Zamknij </button>
                </div>

              </div>
          </div>
        </div>
        
    </div>

</template>

<script>

    import { bus } from './main';     


    export default {
     
       name: 'NauProposalView',



       data(){

            return {

              modal: null,

              details: '',

              // Slider configuration
              minAmount: 1000,
              maxAmount: 1000,
              step: 100,
              labelValues: [1000, 1000],
              sliderLabels: [],

              waitCount: 0
              
            }
       },


       computed: {


        formatedAmount(){

          return this.formatCurrency(this.loanAmount) + ' zł';
        },


        installmentAmount(){

            return (this.total / this.loanTenor).toFixed(2);
        }
         


       },


       methods: {


        onInput(v){

          // Przelicz wartości przy zmianie suwaka
          this.setValues(v, this.loanTenor, this.tenorSign);

        },


        initSlider(){

          // Inicjalizacja slidera z maksymalną wartością z propozycji
          this.maxAmount = this.loanAmount;
          this.labelValues = [this.minAmount, this.loanAmount];

          // Generowanie etykiet dla slidera
          this.sliderLabels = this.labelValues.reduce((accu, itm) => {

            if (!accu){
              return [itm];
            }

            return accu.concat( ...Array( (Math.abs(accu[accu.length-1] - itm) / this.step) - 1 ) ).concat( itm );
          }, 0);

        },


        accept(){


            var page = this.$root.mainpage;


            page.isLoading = 'to może potrwać do 2 minut..,prosimy o cierpliwość..,przygotowujemy dokumenty..';
            this.waitCount = 0;



           // this.post( '/score')
            this.post( '/counteroffer', {amount: this.loanAmount})
              .then(response => {

                if (!!response.data) {
                  let ok = !(response.data.IS_ERROR | 0);


                  this.onWaiting();              

                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {           
                     console.log(error.response);
                  }                                  
              });





        },

        resign(){



            this.post( '/resign' )
              .then(response => {

                if (!!response.data) {
                  let ok = !(response.data.IS_ERROR | 0);


                    this.$router.push({path: 'resign'});
                }           
              })
              .catch(error => {
             
                  // Error 
                  if (error.response) {           
                     console.log(error.response);
                  }                                  
              });



        },



        gotomain(){

            this.$router.push({path: '/'});
        },




        onWaiting( endpoint='application' ) {


          var page = this.$root.mainpage,
              step,


            poll = () => {

              if (this.waitCount > 60){

                page.isLoading =false;
                return;
              }

              this.waitCount++;


              this.get( '/' + endpoint )
                  .then(response => {
                   

                    if (!!response.data) {

                      step = response.data.hasOwnProperty('step') ? response.data.step : '';

    //console.log(step);

                      switch (step) {

                        case 'counteroffer':
                        case 'wait':
                          break;

                        case 'account':
                          page.isLoading =false;
                          this.$router.push({path: 'account'});
                          return;

                        case 'reject':
                          page.isLoading =false;
                          this.$router.push({path: 'rej'});
                          return;

                        default:
                          page.isLoading =false;
                          this.$router.push({path: 'thankyou'});
                          return;
                      }


    //console.log(response.data)

                   
                    }
                    else {
                      console.log('status empty body');
                    }


                    // dispatch another poll request
                    page.isLoading
                      && setTimeout(poll, 3000);                



                  })
                  .catch(error => {
                   
                      // wait for timeout
                      //page.isLoading = false;
                      setTimeout(poll, 3000);

         
                      // Error 
                      if (error.response) {
                     

                      } else if (error.request) {
                        
                      } else {
                          // Something happened in setting up the request and triggered an Error
                          //console.log('Error', error.message);
                      }
                  });


            };


            // initial polling
            setTimeout(poll, 3000);
        },




        openModal(v){

          this.details = this.getModalContent('info_form');

          this.modal.show();

        }




       },


       created() {

          // Inicjalizacja slidera
          this.initSlider();

       },


    mounted(){


      // check if ais was completed
      if (!this.$root.mainpage.aisdone) {

        this.$router.push({path: '/client'})
      }
      else {

        this.$root.mainpage.aisdone = false;
      }



      this.modal = new bootstrap.Modal(this.$refs['modal']);


      // scroll to top
      this.pageTop();

    }



        
    }
</script>

<style scoped>

/* === Entry Title === */
.entry-title {
    font-size: 32px;
    margin: 2.8em 0 2em;
    text-align: center;
    color: #045439;
}

.entry-title i {
    color: #0bc268;
}

/* === Offered Amount === */
h1.offered {
    font-size: 3.5rem;
    color: #045439;
    font-weight: bold;
}

/* === Calc Widget Container === */
#calc-app.wrapper.calc.proposal {
    box-shadow: 0px 12px 30px #0000001a;
    border-radius: 36px;
    overflow: hidden;
}

/* === Params Section with Gradient (like .calc .params) === */
#calc-app .params {
    background-image: linear-gradient(0deg, #00605c, #0bc268);
    color: #fff;
    padding: 20px 30px 15px;
}

.slider-label {
    font-size: 1rem;
    color: #fff;
    margin-bottom: 0.5rem;
    font-weight: 500;
}

/* === Vuetify Slider Override for dark background === */
#calc-app .params .amount-slider .v-slider--horizontal .v-slider__tick .v-slider__tick-label {
    color: #fff;
    font-size: 12px;
}

#calc-app .params .v-slider__track-fill {
    background-color: #fff !important;
}

#calc-app .params .v-slider__thumb {
    background-color: #fff !important;
    border: 3px solid #007666 !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

#calc-app .params .v-slider__thumb:before {
    background-color: #fff !important;
}

#calc-app .params .v-slider__track-background {
    background-color: rgba(255, 255, 255, 0.3) !important;
}

/* === Details Section (like .calc .details) === */
#calc-app .details .tab-content {
    background-color: #fff;
    padding: 0px 30px 0px 30px;
    border-radius: 0 0 36px 36px;
}

/* === Loan Details (from custom.css .loan-details) === */
.loan-details .row {
    border-bottom: 1px solid #e5e5e5;
    padding: .5rem;
}

.loan-details .row:last-child {
    border-bottom: 0;
}

.loan-details .row .col {
    padding: 0;
}

.loan-details .row.summary {
    font-weight: bold;
    color: #045439;
    font-size: 1.1rem;
    border-bottom: 0;
    margin-top: 0.5rem;
    padding-top: 0.75rem;
    border-top: 2px solid #007666;
}

/* === Info Link (like .calc a.plain) === */
.info-link a.plain {
    color: #007666;
    text-decoration: underline;
    font-size: .9rem;
    transition: color 0.2s ease;
}

.info-link a.plain:hover {
    color: #0bc268;
}

/* === Buttons === */
.form-button {
    cursor: pointer;
    min-width: 160px;
    font-size: 14px;
    padding: 14px 32px;
    line-height: 16px;
    border-radius: 40px;
    border: 2px solid;
    margin: 0 0.5rem;
    font-weight: 600;
    transition: all ease 0.8s;
}

.form-button .icon {
    font-size: 0.7rem;
    margin: 0 0.5rem;
}

/* Primary Button (ZGADZAM SIĘ) */
.form-button.btn-outline-primary {
    color: #fff;
    border-color: #007666;
    background-color: #007666;
}

.form-button.btn-outline-primary:hover {
    box-shadow: inset 230px 0 0 0 #0bc268;
    border-color: #0bc268;
    background-color: #0bc268;
}

/* Secondary Button (REZYGNUJĘ) */
.form-button.btn-outline-secondary {
    color: #045439;
    border-color: #007666;
    background-color: transparent;
}

.form-button.btn-outline-secondary:hover {
    box-shadow: inset -230px 0 0 0 #00605c;
    border-color: #00605c;
    background-color: #00605c;
    color: #fff;
}

/* === Modal === */
.modal-dialog {
    max-width: 900px;
}

.modal-content {
    border-radius: 20px;
    overflow: hidden;
    border: none;
}

.modal-header {
    display: flex;
    padding: 1.25rem 1.5rem;
}

.modal-header h3 {
    color: #fff;
    margin: 0;
    font-size: 1.25rem;
}

.modal-body {
    overflow-y: auto;
    padding: 1.5rem;
}

.modal-footer {
    border-top: 1px solid #e9ecef;
    padding: 1rem;
}

.modal-footer .btn-success {
    background-color: #007666;
    border-color: #007666;
    border-radius: 40px;
    padding: 0.75rem 2rem;
    transition: all 0.3s ease;
}

.modal-footer .btn-success:hover {
    background-color: #0bc268;
    border-color: #0bc268;
}

/* === Responsive === */
@media (max-width: 575px) {
    h1.offered {
        font-size: 2.5rem;
    }

    .entry-title {
        font-size: 24px;
        margin: 1.5em 0 1em;
    }

    .form-button {
        min-width: 130px;
        padding: 12px 20px;
        font-size: 13px;
        margin: 0.25rem;
    }

    #calc-app .params {
        padding: 15px 20px 10px;
    }

    #calc-app .details .tab-content {
        padding: 0px 20px 0px 20px;
    }
}

</style>


// WEBPACK FOOTER //
// src/NauProposalView.vue